module.exports = __webpack_public_path__ + "img/icon_jifen_expired.0fba28fe.png";